import { FC } from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { chartColorList } from './constants';
import { ChartAttachment, PieChartData } from '../../pages/Chat/Chat/types';

const MindyPieChart: FC<ChartAttachment> = ({ data, options }) => {
    // the data source should have a list of objects to describe a pie,
    //  every object is a pie level
    if (
        !Array.isArray(data) ||
        data.some(
            (pie) =>
                !Array.isArray(pie) ||
                pie.some((section) => Object.keys(section).length !== 2) ||
                pie.some(
                    (section) => !Object.keys(section).includes('name') || !Object.keys(section).includes('value'),
                ),
        )
    ) {
        console.error(
            'Invalid data format for PieChart. Expected an array of arrays of objects with two keys: name and value.',
        );
        return null;
    }

    const customLabel = ({ percent }: { percent: number }) => `${(percent * 100).toFixed(0)}%`;

    const pieCount = (data as PieChartData[][]).length;
    const pieGap = pieCount > 1 ? 10 : 0;
    const pieHeight = 100 / pieCount - pieGap;

    return (
        <div className="w-full h-[250px]">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    {(data as PieChartData[][]).map((pie, indexPie) => (
                        <Pie
                            dataKey="value"
                            isAnimationActive={true}
                            data={pie as PieChartData[]}
                            cx="50%"
                            cy="50%"
                            innerRadius={indexPie * pieHeight + pieGap / 2}
                            outerRadius={indexPie * pieHeight + pieHeight - pieGap / 2}
                            fill="#8884d8"
                            labelLine={pieCount === indexPie + 1}
                            label={
                                pieCount === indexPie + 1
                                    ? options?.pieShowAsPercentage
                                        ? customLabel
                                        : true
                                    : undefined
                            }
                        >
                            {pie.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={chartColorList[index % chartColorList.length]} />
                            ))}
                        </Pie>
                    ))}
                    {options?.showLegend && <Legend />}
                    <Tooltip />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MindyPieChart;
